module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19e19CF/tc-custom/9781423638087.jpg?1718282660248",
      "alt": "This image is the cover for the book I Love Ramen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("I Love Ramen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Use your noodle with these")]), _vm._v(" "), _c('b', [_vm._v("75 recipes for turning a dorm-room staple into scrumptious meals!")])]), _c('p', [_vm._v("If necessity is the mother of invention, a college student’s food budget certainly led to the invention of some delicious ways with one of the least expensive, most convenient packaged foods of all time. This cookbook, from a ramen maven who’s appeared on the Food Network, is filled with taste-tempting photos and shows that the humble block of ramen noodles can be magically transformed into delicious main dishes as well as sides, soups and salads. There are even a couple of desserts based on the ever-popular ramen noodle! ")]), _c('p', [_vm._v("Recipes include: Beef & Broccoli Stir-fry * Crab Lo Mein * Baked Stuffed Tomatoes * Fiesta Chicken * Cheesy Bacon Noodles * Ramen Rolled Steak * Tangerine Chicken Salad * Thin Mint on a Stick * and many more")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Toni Patrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0